// utils/tenantHost.js
//
// WHICH TENANT'S SUBDOMAIN is this app running on? (decisions log #4 — every
// tenant lives on <subdomain>.<base domain>, nginx/Traefik routes them all to
// the same SPA build.)
//
// The answer rides on every API call as the X-Tenant-Subdomain header
// (hooks/useAxiosAuth.js); the backend resolves it to the tenant and uses it
// as the login's default organisation selection. It SELECTS a login page —
// it grants nothing; credentials still have to match an account at that
// tenant.
//
// Dev servers run on localhost where the hostname says nothing — set
// localStorage.devTenantSubdomain = 'apollo' to impersonate a tenant host.

const BASE_DOMAIN = (import.meta.env.VITE_TENANT_DOMAIN || 'mitra-one-care.com')
    .trim().toLowerCase();

const SUBDOMAIN_RE = /^[a-z0-9](?:[a-z0-9-]{1,61}[a-z0-9])?$/;

// Hostnames under the base domain that are the PLATFORM's, not a hospital's:
// app. is the shared login host, sa. the Super Admin console, and the rest
// are reserved the same way on the backend (tenantManagementController
// RESERVED_SUBDOMAINS). On app.mitraonecare.com the label 'app' looked like a
// tenant subdomain and the shared login hid its subdomain field (25 Sep 2026).
const PLATFORM_LABELS = new Set([
    'www', 'app', 'sa', 'api', 'admin', 'superadmin', 'moc', 'meet', 'ai', 'mail',
    'smtp', 'ftp', 'static', 'cdn', 'assets', 'portal', 'login', 'auth',
    'support', 'help', 'docs', 'status', 'minio', 's3',
]);

/** The tenant subdomain of the current hostname, or null on the MOC host. */
export function getTenantSubdomain() {
    try {
        const dev = (localStorage.getItem('devTenantSubdomain') || '').trim().toLowerCase();
        if (dev) return SUBDOMAIN_RE.test(dev) ? dev : null;
    } catch { /* storage unavailable — fall through to the hostname */ }

    const host = window.location.hostname.toLowerCase();
    if (!host.endsWith(`.${BASE_DOMAIN}`)) return null;
    const label = host.slice(0, -(BASE_DOMAIN.length + 1));
    if (!label || label.includes('.') || PLATFORM_LABELS.has(label)) return null;
    return SUBDOMAIN_RE.test(label) ? label : null;
}

export default getTenantSubdomain;
